import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  Aangifte, BokkzAlgDataService,
  BokkzIbDataService,
  IncomeTaxEntity,
  LijfrentePremie
} from "@snelstart-ventures/fiscaal/domain-logic";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommandModule } from '@angular/cli/src/command-builder/command-module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-premies-anw',
  templateUrl: './premies-anw.component.html',
  styleUrls: ['./premies-anw.component.scss'],
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class PremiesAnwComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription | undefined;
  private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
  private isDefAangifteSubscription: Subscription | undefined;
  private isSaving = false;
  public clientId!: string;

  @Input() public id!: string;
  public aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;

  public partnerBoolean = {} as boolean;
  @Input() partner = new BehaviorSubject<boolean>(false);
  private partnerAangifte = {} as Aangifte;

  public isDefAangifte = {} as boolean;

  private focusedElementId: string | null = null;

  public premieANW = {} as FormGroup;

  constructor(
    public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
    private router: Router,
    private fb: FormBuilder) {
    this.premieANW = this.fb.group({
      betaaldePremieANW: this.fb.array<LijfrentePremie>([]),
    });
  }

  get betaaldePremieANW(): FormArray {
    return this.premieANW.get('betaaldePremieANW') as FormArray;
  }

  addRijLoonPremieANW(): void {
    this.betaaldePremieANW.push(this.createPremieANWFormGroup());
  }

  verwijderRijPremieANW(index: number): void {
    this.betaaldePremieANW.removeAt(index);
    this.premieANW.updateValueAndValidity()
    this.premieANW.markAsDirty()
    this.saveForm();
  }



  createPremieANWFormGroup(premie?: LijfrentePremie): FormGroup {
    return this.fb.group({
      omschrijving: premie ? premie?.omschrijving : undefined,
      bedrag: premie ? premie.bedrag : undefined,
      polisnummer: premie ? premie.polisnummer : undefined,
    } as LijfrentePremie);
  }

  public ngOnInit(): void {
    this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
      this.isDefAangifte = isDefAangifte;
    });
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
      this.incomeTaxEntity = incomeTaxEntity;
      if (incomeTaxEntity.aangifte) {
        const aangifte = incomeTaxEntity.aangifte;
        this.aangifte = aangifte;
        this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : ({} as Aangifte);
        this.updateForm();
        this.partner.subscribe((partner) => {
          this.partnerBoolean = partner;
          this.premieANW.reset();
          this.updateForm();
        });
      }
    });
    this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
      this.clientId=client.sstRelationId!;
    })
    this.routerSubscription = this.router.events
      .pipe(
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleUrlChange(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
    if (this.isDefAangifteSubscription) {
      this.isDefAangifteSubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.premieANW.dirty
  }

  private updateForm(): void {
    let premieANWLijst =
      this.aangifte?.box1?.uitgavenVoorInkomensvoorzieningen
        ?.lijfrentePremiesANW || [];
    this.partner.subscribe((partner) => {
      if (partner) {
        premieANWLijst =
          this.aangifte?.partnerAangifte?.box1
            ?.uitgavenVoorInkomensvoorzieningen?.lijfrentePremiesANW || [];
      }
    });

    const formArrayANW = this.premieANW.get('betaaldePremieANW') as FormArray;
    const focusedControl = this.focusedElementId
      ? (document.getElementById(this.focusedElementId) as HTMLElement)
      : null;
    while (
      formArrayANW != null &&
      formArrayANW.length > premieANWLijst.length
    ) {
      formArrayANW.removeAt(formArrayANW.length - 1);
    }
    // Add or update controls
    for (let j = 0; j < premieANWLijst.length; j++) {
      if (j < formArrayANW.length) {
        // Update existing control
        const control = formArrayANW.at(j) as FormGroup;
        control.patchValue(premieANWLijst[j]);
      } else {
        // Add new control
        const formGroup = this.createPremieANWFormGroup(premieANWLijst[j]);
        formArrayANW.push(formGroup);
      }
    }

    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  saveForm(): void {
    if (!this.partnerBoolean) {
      this.incomeTaxEntity.aangifte = {
        ...this.aangifte,
        box1: {
          ...this.aangifte.box1,
          uitgavenVoorInkomensvoorzieningen: {
            ...this.aangifte.box1?.uitgavenVoorInkomensvoorzieningen,
            lijfrentePremiesANW: this.premieANW.value.betaaldePremieANW,
          },
        },
      } as Aangifte;
      this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    } else {
      this.incomeTaxEntity.aangifte = {
        ...this.aangifte,
        partnerAangifte: {
          ...this.aangifte.partnerAangifte,
          box1: {
            ...this.aangifte.partnerAangifte?.box1,
            uitgavenVoorInkomensvoorzieningen: {
              ...this.aangifte.partnerAangifte?.box1
                ?.uitgavenVoorInkomensvoorzieningen,
              lijfrentePremiesANW: this.premieANW.value.betaaldePremieANW,
            },
          },
        },
      } as Aangifte;
      this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
  }
}
